// @ts-ignore
import styled, { css, keyframes } from "styled-components/macro";

export const popInKeyframes = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const shrinkKeyframes = keyframes`
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.7);
  }
`;

type WrapperTransientProps = {
  $isVisible: boolean;
  $durationMs: number;
  $easing: string;
  $animateOnFocusWithin: boolean;
};

export const Wrapper = styled.div<WrapperTransientProps>`
  opacity: ${(props: WrapperTransientProps) => (props.$isVisible ? 1 : 0)};
  pointer-events: ${(props: WrapperTransientProps) => (props.$isVisible ? "auto" : "none")};
  animation: ${(props: WrapperTransientProps) => (props.$isVisible ? popInKeyframes : shrinkKeyframes)}
    ${(props: WrapperTransientProps) => props.$durationMs}ms ${(props: WrapperTransientProps) => props.$easing} forwards;

  ${(props: WrapperTransientProps) =>
    props.$animateOnFocusWithin
      ? css`
          &:focus-within {
            opacity: 1;
            pointer-events: auto;
            animation: ${popInKeyframes} ${props.$durationMs}ms ${props.$easing} forwards;
          }
        `
      : ""}
`;
